import { Notification } from '@bfa/common-ui';
import { IpsyTheme } from '@bfa/themes';
import React from 'react';
import { NBSimpleBannerKind } from '../../types/enums';
import { Link, Paragraph } from './Notification.styled';
import useNotification from './useGetNotification';
var RefreshmentNotification = function () {
    var _a = useNotification(), bannerToShow = _a.bannerToShow, isBannerVisible = _a.isBannerVisible, handleOnClick = _a.handleOnClick;
    var colorNotification = (bannerToShow === null || bannerToShow === void 0 ? void 0 : bannerToShow.kind) === NBSimpleBannerKind.INFO
        ? IpsyTheme.colors.refreshmentsDarkest
        : undefined;
    if (!isBannerVisible)
        return null;
    return (React.createElement(Notification, { noMarginBottom: true, type: bannerToShow.kind === NBSimpleBannerKind.ERROR ? 'error' : undefined, color: colorNotification, scrollToOnShow: true }, bannerToShow.link ? (React.createElement(Paragraph, { "data-e2e-selector": "notification", "data-testid": "notification" },
        React.createElement(Link, { "data-testid": "notification-link", onClick: handleOnClick }, bannerToShow.text))) : (React.createElement(Paragraph, { "data-e2e-selector": "notification", "data-testid": "notification" }, bannerToShow.text))));
};
export default RefreshmentNotification;
